// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel.discriminator = undefined;
EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel.additionalProperties = false;
EnterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel.attributeTypeMap = [
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "RoleType"
    },
    {
        "name": "accountRelations",
        "baseName": "accountRelations",
        "type": "Array<EnterpriseCoordinatorAccountServiceModelsAccountOrderRelationModel>"
    },
];
//# sourceMappingURL=enterpriseCoordinatorAccountServiceModelsAccountPayorRelationModel.js.map